import PropTypes from 'prop-types'

const AnalyticsCard = ({ text, value, icon }) => (
  <div className="analytics-card">
    {icon}
    <span className="analytics-card__value">{value}</span>
    <span className="analytics-card__desc">{text}</span>
  </div>
)

AnalyticsCard.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.node,
  value: PropTypes.string,
}

export default AnalyticsCard
